<mat-toolbar color="primary">
  <mat-toolbar-row >
      <img  src="assets/images/vibe_banner.png" height="55px" width="146">
      <div style="margin-left: 5px;" fxHide.gt-xs>
          <button mat-icon-button><mat-icon>menu</mat-icon></button> 
      </div>
      <div fxFlex></div>
      <div *ngIf="loggedIn" fxLayout="row" fxHide.xs>
          <button *ngIf= "showHomeButton()" mat-button (click)="homeButtonClicked()"><mat-icon>home</mat-icon></button>        
          <button *ngIf="showUserMenu()" mat-button [matMenuTriggerFor]="userMenu"><mat-icon>account_circle</mat-icon></button>
      </div>
      <mat-menu  #userMenu="matMenu">
        <!--      <p style="text-align: center;">Manjunath</p>-->
        <!--      <mat-divider></mat-divider> -->
        <!--      <p style="text-align:center">Admin User</p> -->
        <!--      <mat-divider></mat-divider> -->
              <button  mat-menu-item (click)="signoutClicked()">Sign out</button>
          </mat-menu>
  </mat-toolbar-row>
  </mat-toolbar>
  <router-outlet></router-outlet>